const numberWithCommas = (x: number | string): string => {
    const num = Number(x);

    if (!Number.isNaN(num)) {
        return new Intl.NumberFormat("en-US").format(num);
    }

    return `${x}`;
};

export default numberWithCommas;
